import React from "react";
import { Redirect } from "react-router-dom";
import { Form, Image, Modal } from "semantic-ui-react";
import styled from "styled-components";
import CheckActive from "../assets/check-active.png";
import CheckInactive from "../assets/check-inactive.png";
import CheckYellow from "../assets/check-yellow.png";
import dateTimeHelper from "../util/dateTimeHelper";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import TabBar from "./common/TabBar";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const TabGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 0px;
  background-color: white;
`;

const Tab = styled.div`
  margin-top: 0px;
  width: 50%;
  text-align: center;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  user-select: none;
`;

const TabSelected = styled.div`
  margin-top: 0px;
  width: 50%;
  border-bottom-style: solid;
  border-bottom-size: 2px;
  border-bottom-color: #eda142;
  text-align: center;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  user-select: none;
`;

const TestDetailTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 5px;
  margin-top: 20px;
`;

const TestDetailDate = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`;

const PlainText = styled.div`
  font-size: 14px;
`;

const ErrorFrame = styled.div`
  border-style: solid;
  border-size: 1px;
  border-color: black;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  margin-left: 30px;
  margin-right: 30px;
`;

class TestDetail extends BaseComponent {
  constructor() {
    super();
    this.state = {
      testResultDetail: null,
      testResultPropertyValues: false,
      testResultImage: null,
      showTabBar: false,
      selectedTabIndex: 0,
      showLargeImage: false,
      showLoader: false,
    };
    this.getTestResultPropertyValues = this.getTestResultPropertyValues.bind(
      this
    );
    this.openTestResultViewer = this.openTestResultViewer.bind(this);
    this.switchTab = this.switchTab.bind(this);
    this.submitDispute = this.submitDispute.bind(this);
    this.validDate = this.validDate.bind(this);
  }

  async componentDidMount() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({
      testResultDetail: this.props.location.state.testResultDetail,
      showLoader: true,
    });

    this.getTestResultPropertyValues();
    const response = await this.safeFunApi.getTestResultImage(
      this.props.location.state.testResultDetail.sF_TestResultId
    );
    this.setState({
      testResultImage: response.data,
      showLoader: false,
    });
  }

  async getTestResultPropertyValues() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoader: true });
    try {
      const response = await this.safeFunApi.getTestResultPropertyValues(
        this.props.location.state.testResultDetail.sF_TestResultId
      );
      const trpv = response.data;
      var errors = [];
      var i;
      for (i = 0; i < trpv.length; i++) {
        if (trpv[i].matchInfo !== null) {
          errors.push(trpv[i]);
        }
      }

      this.setState({ testResultPropertyValues: errors });
    } catch (err) {
      console.log(err);
      this.errorManager.addError(err.toString());
      this.forceUpdate();
    }
    this.setState({ showLoader: false });
  }

  async openTestResultViewer() {
    this.setState({ showLargeImage: true });
  }

  switchTab(data) {
    this.setState({ selectedTabIndex: data });
  }

  async submitDispute() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoader: true });
    await this.safeFunApi.disputeTestResult(this.state.testResultDetail);
    this.setState({
      testResultDetail: { ...this.state.testResultDetail, disputeStatus: 1 },
      showLoader: false,
    });
  }

  validDate(dateValue) {
    return dateValue != null && new Date(dateValue) > new Date();
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Test Detail" />
        <SFLoader active={this.state.showLoader} />
        <MainContentWrapper>
          <TabBar mytests />
          <Wrapper>
            {this.state.showTabBar ||
            (this.state.testResultDetail &&
              this.state.testResultDetail.disputeStatus !== 0) ? (
              <TabGroup>
                {this.state.selectedTabIndex === 0 ? (
                  <>
                    <TabSelected
                      style={{
                        borderRightWidth: 1,
                        borderRightStyle: "solid",
                        borderRightColor: "black",
                      }}
                    >
                      Details
                    </TabSelected>
                    <Tab
                      onClick={() => {
                        this.setState({ selectedTabIndex: 1 });
                      }}
                    >
                      Dispute
                    </Tab>
                  </>
                ) : (
                  <>
                    <Tab
                      style={{
                        borderRightWidth: 1,
                        borderRightStyle: "solid",
                        borderRightColor: "black",
                      }}
                      onClick={() => {
                        this.setState({ selectedTabIndex: 0 });
                      }}
                    >
                      Details
                    </Tab>
                    <TabSelected>Dispute</TabSelected>
                  </>
                )}
              </TabGroup>
            ) : null}

            {this.state.testResultDetail &&
            this.state.selectedTabIndex === 0 ? (
              <Wrapper>
                <TestDetailTitle>
                  {this.state.testResultDetail.testingCompanyName +
                    " " +
                    this.state.testResultDetail.publicName}
                </TestDetailTitle>
                <TestDetailDate>
                  {dateTimeHelper.formatDate(
                    this.state.testResultDetail.testDate
                  )}
                </TestDetailDate>

                {this.state.testResultDetail.valid === 0 ? null : (
                  <Image
                    src={
                      this.validDate(
                        this.state.testResultDetail.strongSafetyDate
                      )
                        ? CheckActive
                        : this.validDate(
                            this.state.testResultDetail.weakSafetyDate
                          )
                        ? CheckYellow
                        : CheckInactive
                    }
                    height={32}
                    width={32}
                  />
                )}
                {this.state.testResultImage ? (
                  <Image
                    src={"data:image/jpeg;base64," + this.state.testResultImage}
                    height={250}
                    width={200}
                    bordered
                    style={{
                      borderColor:
                        this.state.testResultDetail.valid === 1
                          ? "#1cbff2"
                          : "red",
                      borderWidth: 2,
                      cursor: "pointer",
                      marginTop: 10,
                      marginBottom: 20,
                    }}
                    onClick={() => {
                      this.openTestResultViewer();
                    }}
                  />
                ) : null}

                <Modal open={this.state.showLargeImage}>
                  <Image
                    src={"data:image/jpeg;base64," + this.state.testResultImage}
                    height={1250}
                    width={1000}
                    bordered
                    style={{
                      borderColor:
                        this.state.testResultDetail.valid === 1
                          ? "#1cbff2"
                          : "red",
                      borderWidth: 2,
                      cursor: "pointer",
                    }}
                    onClick={() => this.setState({ showLargeImage: false })}
                  />
                </Modal>

                {this.state.testResultPropertyValues.length &&
                this.state.testResultPropertyValues.length > 0 ? (
                  <>
                    <PlainText style={{ marginBottom: 20 }}>
                      This test result had the following errors:
                    </PlainText>
                    {this.state.testResultPropertyValues.map((item) => (
                      <ErrorFrame key={item.sF_TestResultPropertyValueId}>
                        <PlainText style={{ margin: 10 }}>
                          {item.name + ":"}
                        </PlainText>
                        <PlainText style={{ margin: 10 }}>
                          {item.matchInfo}
                        </PlainText>
                      </ErrorFrame>
                    ))}
                  </>
                ) : (
                  <PlainText>
                    This test result was processed successfully.
                  </PlainText>
                )}

                {this.state.testResultDetail.valid === 0 &&
                !this.state.showTabBar &&
                this.state.testResultDetail.disputeStatus === 0 ? (
                  <PillButton
                    primary
                    style={{ width: "200px", marginTop: 20 }}
                    onClick={() => {
                      this.setState({
                        showTabBar: true,
                        selectedTabIndex: 1,
                      });
                    }}
                  >
                    Dispute
                  </PillButton>
                ) : null}
              </Wrapper>
            ) : null}

            {this.state.selectedTabIndex === 1 ? (
              this.state.testResultDetail.disputeStatus === 0 ? (
                <div
                  style={{
                    marginTop: 20,
                    marginRight: 30,
                    marginLeft: 30,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <PlainText
                    style={{
                      fontSize: 16,
                      marginBottom: 20,
                      textAlign: "center",
                    }}
                  >
                    We can help resolve minor differences in submitted documents
                    such as typos. Please describe below and submit.
                  </PlainText>

                  <Form
                    style={{
                      marginBottom: 20,
                      width: "100%",
                    }}
                  >
                    <Form.TextArea
                      style={{}}
                      maxLength={1000}
                      value={this.state.testResultDetail.disputeComment}
                      onChange={(e) => {
                        this.setState({
                          testResultDetail: {
                            ...this.state.testResultDetail,
                            disputeComment: e.target.value,
                          },
                        });
                      }}
                    ></Form.TextArea>
                  </Form>
                  <PillButton
                    primary
                    style={{ width: "200px" }}
                    disabled={
                      !this.state.testResultDetail.disputeComment ||
                      (this.state.testResultDetail.disputeComment &&
                        this.state.testResultDetail.disputeComment.length === 0)
                    }
                    onClick={() => {
                      this.submitDispute();
                    }}
                  >
                    Submit
                  </PillButton>
                </div>
              ) : (
                <div
                  style={{
                    marginTop: 20,
                    marginRight: 30,
                    marginLeft: 30,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <PlainText
                    style={{
                      fontWeight: "bold",
                      fontSize: 16,
                      marginBottom: 20,
                    }}
                  >
                    Your Submission
                  </PlainText>
                  <PlainText
                    style={{
                      fontSize: 16,
                      marginBottom: 20,
                    }}
                  >
                    {this.state.testResultDetail.disputeComment}
                  </PlainText>

                  {this.state.testResultDetail.disputeResponseComment ? (
                    <>
                      <PlainText
                        style={{
                          fontWeight: "bold",
                          fontSize: 16,
                          marginBottom: 20,
                        }}
                      >
                        SafeFun Response
                      </PlainText>
                      <PlainText
                        style={{
                          fontWeight: "300",
                          fontSize: 16,
                          marginBottom: 20,
                        }}
                      >
                        {this.state.testResultDetail.disputeResponseComment}
                      </PlainText>
                      <PlainText
                        style={{
                          fontWeight: "300",
                          fontSize: 16,
                          marginBottom: 20,
                        }}
                      >
                        If you have any other questions, please contact us by
                        clicking the button below.
                      </PlainText>
                      <div
                        style={{
                          marginTop: 20,
                          marginRight: 30,
                          marginLeft: 30,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <PillButton
                          primary
                          style={{ width: "200px" }}
                          onClick={() => {
                            //Linking.openURL("mailto:support@safefun.com");
                          }}
                        >
                          Contact
                        </PillButton>
                      </div>
                    </>
                  ) : (
                    <>
                      <PlainText
                        style={{
                          fontSize: 16,
                          marginBottom: 20,
                        }}
                      >
                        Thank you for submitting your dispute. We will email you
                        at your provided email address when we have reviewed
                        your dispute. We are generally able to review all
                        disputes within 3 hours of submission.
                      </PlainText>
                    </>
                  )}
                </div>
              )
            ) : null}

            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default TestDetail;
